import { Component, OnInit, Input } from '@angular/core';
import { CourseBundle } from 'lms-api';
import { LoginComponent } from '../login/login.component';
import { UserCourseFeeService } from 'lms-api';
import { ShoppingCartService } from 'lms-api';
import { LmsUserService } from 'lms-api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-bundle-to-cart',
  templateUrl: './add-bundle-to-cart.component.html',
  styleUrls: ['./add-bundle-to-cart.component.scss']
})
export class AddBundleToCartComponent implements OnInit {
  @Input() bundle: CourseBundle;
  public fee$;
  public IsInCart: boolean;

  constructor(public userFeeService: UserCourseFeeService, public cartService: ShoppingCartService, public userService: LmsUserService, public modalService: NgbModal) {

  }

  ngOnInit(): void {
    this.fee$ = this.userFeeService.GetBundleFee(this.bundle.product_code);
    this.cartService.CartDetails.subscribe(cart => {
      this.IsInCart = this.cartService.IsItemInCart(this.bundle.product_code);
    });
  }

  public AddBundleToCart() {
    this.cartService.AddBundle(this.bundle.product_code).subscribe();
  }

  public RemoveBundleFromCart() {
    this.cartService.RemoveBundle(this.bundle.product_code).subscribe();
  }

  public ShowLoginModal() {
    this.modalService.open(LoginComponent);
  }

}
